const $body = $('body');
// node modules
// import "jquery-sparkline"
// import "jquery-knob"
// import "jquery-countdown"
// import "jquery.easing"
// import "simplebar"
// import "@chenfengyuan/datepicker"
import "dropzone"
// import "chart.js"
// import "pdfmake"
import * as JSZip from "jszip" // required by datatables/buttons/html5
// inits
import "./plugins/abort-ajax"
import "./plugins/bootstrap/bootstrap"
import "./plugins/sweet-alert/sweet-alert-popup"
import "./plugins/cookies-info-bar"
import "./plugins/copy-values-as-same"
import {attachDataTables} from "./plugins/datatables";
import "./plugins/dropdown-menu"
import {attachInputMask} from "./plugins/inputmask";
import "./plugins/left-menu-collapse"
import "./plugins/metis-menu"
import "./plugins/node-waves"
import "./plugins/parsley"
import "./plugins/password-validation"
import "./plugins/popover"
import "./plugins/preloader"
import "./plugins/remove-invalid-class"
import "./plugins/right-sidebar"
import "./plugins/rotate-statements-switch"
import "./plugins/select2"
import "./plugins/show-password"
import "./plugins/tooltip"
import "./plugins/intl-tel-input"
import "./plugins/repeater"
import attachColorPicker from "./plugins/bootstrap/colorpicker";
import "./plugins/button-with-value";
import "./plugins/cloud-images";
import "./plugins/copy-to-clipboard";
// pages
import "./pages/survey/general"
import "./pages/survey/opening"
import './pages/survey/calibration'
import "./pages/survey/questions"
import "./pages/survey/closing"
import "./pages/survey/redirects"
import "./pages/survey/summary"
import "./pages/admin/cms/recommended-statements/edit"
import './pages/panel/transaction/get-invoice-details'
import './pages/survey/report/summary'
import './pages/admin/company/price-list/index'
import './pages/admin/survey/show'
import './pages/admin/cms/help/edit'
import './pages/admin/cms/popup/create'
import './pages/admin/cms/popup/edit'
import './pages/admin/cms/instructions/edit'
import './pages/admin/points-package/create'
import './pages/admin/points-package/edit'
import './pages/panel/transaction/choose-payment-method'
import './pages/panel/survey/report/show'
import './pages/panel/survey/status/restore'
import './pages/admin/cms/page/edit'
import './pages/panel/company/hide-vat-outside-ue'
import './pages/users/hide-vat-outside-ue'
import "./pages/survey/company/lists/lists"
import "./pages/admin/points-package/history"
import "./pages/admin/invoice/issue/create"
import "./pages/admin/points-package/assign-to-company"

// components
import './components/survey/questions';
import {attachNumber} from "./components/form/number";
import {attachSelect} from "./components/form/select"
import {attachDatepicker} from "./components/form/date"
import "./components/secure-link"
import "./components/form/submit-button";
import {colorSchemeOnStart} from "./components/color-scheme-toggle";
import "./components/popup-for-images";

window.JSZip = JSZip; // required by datatables/buttons/html5
// import "@curiosityx/bootstrap-session-timeout"
// import "tui-calendar"
// import "tui-chart"
// import "tui-date-picker"
// import "tui-dom"
// import "tui-time-picker"
// import "chance"
// import "gmaps"
// import "leaflet"
// import "cropperjs"
// import "owl.carousel"
// import "toastr"
// import "twitter-bootstrap-wizard"
// import "admin-resources/rwd-table/rwd-table.min.js"
// import "ion-rangeslider"
// import "moment"
// import "flot-charts"
// import "magnific-popup"

attachInputMask($body);
attachColorPicker($body);
attachDataTables($body);

colorSchemeOnStart();
attachNumber($body);
attachSelect($body);
attachDatepicker($body);

import * as Sentry from "@sentry/browser";
import {Integrations} from "@sentry/tracing";

window.Sentry = Sentry;
window.Integrations = Integrations;
